
export const buildSellPayload = (flight, apiToken, agencyKey, bookingKey) => ({
  APIToken:   apiToken,
  AgencyKey:  "02AD68F3-9AE6-4148-85B1-E61D1F03991F" ,
BookingKey: bookingKey || "",
  ContractId: flight?.ContractId || flight?.Id || "",
  IsB2B: false
});

export const sellFlight = async (flight, apiToken, agencyKey, bookingKey) => {
  const baseURL = process.env.REACT_APP_FLIGHTS_API_URL;
  if (!baseURL) { console.error("API URL missing"); return null; }

  const payload = buildSellPayload(flight, apiToken, agencyKey, bookingKey); // ✅ pass karo
  console.log("Sell Request Payload:", payload);

  const response = await fetch(`${baseURL}/Trip/Sell`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  const data = await response.json();
  console.log("Sell API Response:", data);
  return data;
};